
export const OPTION_IS_DEEP: { [optionName: string]: boolean } = {
  headerToolbar: true,
  footerToolbar: true,
  events: true,
  eventSources: true,
  resources: true
};

/*
NOTE: keep synced with component
*/
export const OPTION_INPUT_NAMES: string[] = [
  'events',
  'eventSources',
  'resources',
];
